var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLocationColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3k72furd8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 11.318C17 15.454 12 19 12 19s-5-3.546-5-7.682c0-1.41.527-2.763 1.464-3.76C9.402 6.56 10.674 6 12 6s2.598.56 3.536 1.558c.937.997 1.464 2.35 1.464 3.76z",
    stroke: "#500D76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 2,
    fill: "#500D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12H0m12-6V0m5 12h7m-12 7v5",
    stroke: "#500D76",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#500D76",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3k72furd8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLocationColored);
export default __webpack_public_path__ + "static/media/addLocationColored.f9388a8d4284fe656d35bfd010fb5932.svg";
export { ForwardRef as ReactComponent };